import LocalStorage from "../components/LocalStorage";
import storageType from "./storageType";

const initialState = {
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
    loading: false,
    language: LocalStorage.getValue(storageType.LANGUAGE) || 'en',
    supportedLangs: {
        en: 'English',
        th: 'Thai (optional)',
        ru: 'Russian (optional)',
    },
    translations: {},
    sidebar: {
        canvas: false,
    },
    login: {
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: "",
        toggle_password: false,
        user: LocalStorage.getValue(storageType.AUTH_USER) || {},
    },
    forgotPass: {
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: "",
        error: false,
    },
    venue_register: {
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: "",
        toggle_password: false,
        step: 1,
        stepTitle: 'Your business',
        businessType: [],
        countries: [],
        states: [],
        cities: [],
        citySearch: [],
        formData: {
            email: "",
            password: "",
            confirm_password: "",
            business_name: "",
            business_type: 0,
            country_id: 0,
            state_id: 0,
            city_id: 0,
            is_show_tablet: false,
            is_scan_qrcode: false,
            is_food_delivery: false,
            menu_type: 0,
            vertical: '',
            signup_intent: ''
        }
    },
    venue_menu: {
        menu_category: [],
    },
};

export default initialState;
